module.exports = __webpack_public_path__ + "static/img/hg.a713a5d.jpg";